import { WorkspacesListingItem } from '@futrli-sdk/workspaces';

export const SFA_BUSINESS_ID = 'SFA_BUSINESS_ID';

/**
 * Return the business id (bid) from the URL search params
 * @param urlParams - Optional, specify url string here. Defaults to window.location.href.
 */
export const getSfaBusinessIdFromUrl = (href = window.location.href) => {
  const url = new URL(href);
  const searchParams = new URLSearchParams(url.search);
  return searchParams.get('bid');
};

/**
 * Iterates through workspaces listing page endpoint response and returns organisation that
 * has the given businessId (org.sxp_business_id === businessId)
 * @param workspaces list of all workspaces
 * @param businessId sage50 business id
 */
export const getOrgByBusinessId = (workspaces: WorkspacesListingItem[] | null | undefined, businessId: string) => {
  if (workspaces) {
    for (const w of workspaces) {
      for (const o of w.organisations) {
        if (o.sxp_business_id === businessId) {
          return {
            organisation: o,
            workspace: w
          };
        }
      }
    }
  }
  return {};
};

/**
 * Iterates through workspaces listing page endpoint response and returns organisation that
 * has the given id (org.id === id)
 * @param workspaces list of all workspaces
 * @param id organisation id
 */
export const getOrgById = (workspaces: WorkspacesListingItem[] | null | undefined, id: string) => {
  if (workspaces) {
    for (const w of workspaces) {
      for (const o of w.organisations) {
        if (o.id === id) {
          return {
            organisation: o,
            workspace: w
          };
        }
      }
    }
  }
  return {};
};

export const getSfaBusinessId = () => {
  return sessionStorage.getItem(SFA_BUSINESS_ID) || '';
};

export const removeSfaBusinessId = () => {
  sessionStorage.removeItem(SFA_BUSINESS_ID);
};

export const storeSfaBusinessId = (businessId: string) => {
  sessionStorage.setItem(SFA_BUSINESS_ID, businessId);
};
